import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Badge.module.scss';

const Badge = ({
  label = '',
  theme = 'default',
  className = '',
  size = 'default',
  rounded = false,
  ...rest
}) => {
  return (
    <div
      {...rest}
      className={classNames(
        styles.badge,
        className,
        !!theme && styles[`badge--theme-${theme}`],
        !!size && styles[`badge--size-${size}`],
        rounded && styles['badge--rounded']
      )}
    >
      {label}
    </div>
  );
};

Badge.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.oneOf([
    'default',
    'primary',
    'default-light',
    'primary-light',
    'secondary-blue'
  ]),
  size: PropTypes.oneOf(['default', 'small', 'big']),
  className: PropTypes.string,
  rounded: PropTypes.bool
};

export default Badge;
